import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import MapMarker from '../atoms/MapMarker';
import mapStyles from '../data/mapStyles.json';

class Map extends Component {
  render() {
    return (
      <div className="Map">
          <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyAYSEfuCEYkw2hallbTidmqM3a6amcXK5k' }}
            defaultCenter={[Number(this.props.lat),Number(this.props.long)]}
            defaultZoom={11}
            options={{
              scrollwheel: false,
              styles: mapStyles
            }}
          >
              <MapMarker
                lat={this.props.lat}
                lng={this.props.long}
                text="My Marker"
              />
          </GoogleMapReact>
      </div>
    );
  }
}

export default Map;